import reportReasons from '@apis/reportReasons'
import reportResponse from '@apis/reportReasons'
import Button from '@components/button'
import Column from '@components/column'
import Fields from '@components/fields'
import Grid from '@components/grid'
import Row from '@components/row'
import Wrapper from '@components/wrapper'
import useIsMobile from '@hooks/useIsMobile'
import theme from '@utils/theme'
import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'

const ReportResponseForm = ({ selectedReason, setSelectedReason }) => {
  const isMobile = useIsMobile()
  const [initialValues, setInitialValues] = useState({
    gameName: '',
    userRole: '',
    reportReason: '',
    image: '',
  })
  useEffect(() => {
    if (selectedReason) {
      setInitialValues({
        gameName: selectedReason.gameName || '',
        userRole: selectedReason.userRole || '',
        reportReason: selectedReason.reportReason || '',
        image: `${selectedReason.referenceImage}`,
      })
    }
  }, [selectedReason])
  const handleSubmit = async (values: any) => {
    try {
      const payload: any = {
        name: values.gameName,
        reason: values.reportReason,
        role: values.userRole,
      }
      if (!selectedReason) {
        payload.images = [
          {
            base64: values.image.base64,
            extension: values.image.extension,
          },
        ]
      }
      if (!!selectedReason) {
        await reportReasons.update({
          id: selectedReason.id,
          state: 'reportReason',
          data: JSON.stringify(payload),
        })
      } else {
        await reportReasons.create({
          state: 'reportReason',
          data: JSON.stringify(payload),
        })
      }
    } catch (error) {}
  }
  const styleGrid = isMobile
    ? `transform: translateX(0); width: 85%; & > :nth-child(3) { grid-column: 1 / -1; }`
    : `transform: translateX(-20px); width: 250%; & > :nth-child(3) { grid-column: 1 / -1; }`
  return (
    <Wrapper>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        <Form>
          <Column>
            <div
              style={{
                display: 'flex',
                flexDirection: isMobile ? 'column-reverse' : 'row',
              }}
            >
              <Grid stack={true} repeat={2} styleGrid={styleGrid}>
                <Fields.DropDown
                  label="Game Name"
                  name="gameName"
                  options={[
                    { title: 'Pubg', key: 'pubg' },
                    { title: 'Free Fire', key: 'freeFire' },
                  ]}
                  titleAsKey="title"
                  valueAsKey="title"
                  placeholder="ex: Free Fire / Pubg"
                  styleOptionsWrapper="z-index:9999999999999"
                />

                <Fields.DropDown
                  label="User Role"
                  name="userRole"
                  options={[
                    { title: 'Creator', key: 'creator' },
                    { title: 'Joiner', key: 'joiner' },
                  ]}
                  titleAsKey="title"
                  valueAsKey="title"
                  placeholder="Creator/Joiner"
                  styleOptionsWrapper="z-index:9999999999999"
                />
                <Row styleRow="width:103%;transform:translateX(10px)">
                  <Fields.TextArea
                    label="Report Reason"
                    name="reportReason"
                    placeholder="Enter Report Reason"
                  />
                </Row>
              </Grid>

              <Fields.Upload name="image" variant="banner" />
            </div>
            <Row styleRow="justify-content:flex-end;gap:5px">
              <Button
                title="Reset"
                type="reset"
                justify="end"
                width={100}
                styleButton={styleReset}
              />
              <Button
                title={selectedReason ? 'Update' : 'Submit'}
                type="submit"
                justify="end"
                width={100}
              />
            </Row>
          </Column>
        </Form>
      </Formik>
    </Wrapper>
  )
}

export default ReportResponseForm

const styleReset = `
background:transparent;
border:1px solid ${theme.colors.primary};
color:${theme.colors.primary}
`
